export default __webpack_public_path__ + "static/media/P-020.64089dd8.png";